// This is a service that uses the Angular Hono client to make requests to the Dealcore API.
// And this is the only exception for eslint-disable-next-line @nx/enforce-module-boundaries!!!
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { AutocoreType } from '@hyundai/autocore-lib/router';
// ********************************************************************************************
// ********************************************************************************************
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, InjectionToken, type Provider } from '@angular/core';
import { injectAngularHonoClient } from '@pixelgenau/ngx-hono';
import { isHCM } from '../providers/platform.token';
import { FilterObject } from './api-types';
export interface AutocoreApiConfig {
    baseUrl: string;
}

export const AUTOCORE_API_CONFIG = new InjectionToken<AutocoreApiConfig>('APICORE_API_CONFIG');

export function provideAutocoreApiConfig(config: AutocoreApiConfig): Provider {
    return { provide: AUTOCORE_API_CONFIG, useValue: config };
}

@Injectable({ providedIn: 'root' })
export class VehicleApiService {
    http = inject(HttpClient);
    apiConfig = inject(AUTOCORE_API_CONFIG);

    api = injectAngularHonoClient<AutocoreType>({
        url: this.apiConfig.baseUrl,
        withCredentials: true,
    });

    initOptions = {
        init: { headers: { 'x-hcm': isHCM() ? '1' : '0' } },
    };

    async getVehicleList(query?: { page?: number; limit?: number } & FilterObject, similarVehicleId?: number) {
        const request = await this.api.list.$get(
            {
                query: { data: JSON.stringify(query), similarVehicleId: similarVehicleId?.toString() },
            },
            this.initOptions,
        );
        return await request.json();
    }

    async getVehicleDetail(slug: string) {
        const request = await this.api.detail[':slug'].$get({ param: { slug } });
        return await request.json();
    }

    async getNumberOfVehicles(filter: FilterObject = {}) {
        const request = await this.api.list.count.$get(
            {
                query: Object.keys(filter).length > 0 ? { data: JSON.stringify(filter) } : {},
            },
            this.initOptions,
        );
        return request.json();
    }

    async getPagePromise() {
        const request = await this.api.pages['hyundai-promise'].$get();
        return request.json();
    }

    async getOverlayBatteryCertificate() {
        const request = await this.api.pages['overlay-battery-certificate'].$get();
        return request.json();
    }

    async getModelList() {
        const request = await this.api.pages['models'].$get();
        return request.json();
    }

    // async getDebugModels() {
    //     const request = await this.api.debug.$post({
    //         json: {
    //             price: { min: 1000, max: 100_000 },
    //             page: 1,
    //             limit: 9,
    //         },
    //     });
    //     const d = request.json();
    //     return d;
    // }

    async getFilter(dealerId?: string) {
        const request = await this.api.filters.$get({ query: { dealerId } });
        return request.json();
    }
}
